import React, { useEffect, useState } from 'react'
import A_SimpleDialog from '../../../../Atoms/Feedback/Dialogs/A_SimpleDialog'
import ErrorBoundary from '../../error/ErrorBoundary';
import PropTypes from 'prop-types';
import { ExecuteSqlSP } from '../../Renderers/Views/Aggregation/AggregationHelper';
import A_CheckBox from '../../../../Atoms/Inputs/Checkboxes/A_Checkbox';
import { useParams } from 'react-router';
import { CircularProgress, makeStyles } from '@material-ui/core';
import A_Button from '../../../../Atoms/Inputs/Buttons/A_Button';
import { useSelector } from 'react-redux';


const useDefaultStyles = makeStyles({
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
    },
    buttons: {
        display: "flex",
        justifyContent: 'flex-end',
    },
    body: {
        maxHeight: "500px",
        overflow: "scroll"
    },
    loaderContainer:{
        display:"flex",
        width:"100%",
        justifyContent:"center"
    }
});

const KeyFinancialIndicatorForm = (props) => {

    const classes = useDefaultStyles();
    const { handleClose, formResize, open, title, afterClose } = props;
    const [initialData, setInitialData] = useState();
    const [data, setData] = useState()
    const { crmId,pageUrl } = useParams();

    const loggedInUserEmail = useSelector((state) => {
        return state?.oidc?.user?.profile?.email;
    });

    useEffect(() => {
        const fetchData = async () => {
            let payload = [{
                id: "spGetreportdisplay",
                spName: "spGetreportdisplay",
                parameters: {
                    loanId: crmId,
                    reportName: "KFI Metrics Mapping"
                }
            }]
            let res = await ExecuteSqlSP(payload)
            setData(res.spGetreportdisplay)
            setInitialData(res.spGetreportdisplay)
        }
        fetchData()
    }, [])

    const handleCheckBoxClick = (displayName, isChecked) => {
        setData((pre) => {
            let newData = structuredClone(pre);
            newData.forEach(item => {
                if (item.displayName === displayName) {
                    item.enabled = isChecked;
                }
            });

            return newData;
        })
    }

    const handleSave = async () => {
        const jsonObj = {};
        data.forEach((item,i) => {
            if(initialData[i].enabled !== item.enabled){
                let boolVal = item.enabled.toString();
                jsonObj[item.displayName] = boolVal.slice(0,1).toUpperCase() + boolVal.slice(1);
            }
        });
        jsonObj.parentId = crmId;
        jsonObj.id = crmId;
        jsonObj.modifiedBy = loggedInUserEmail;
        jsonObj.modifiedDate = Math.floor(Date.now() / 1000)

        const payload = [{
            id: "uspWriteLoanKPIJSON",
            spName: "Tristan.usp_WriteLoanKPIJSON",
            parameters: {
                json:JSON.stringify(jsonObj)
            }
        }]
        const res =  await ExecuteSqlSP(payload)
        if(res.uspWriteLoanKPIJSON){
            handleClose();
            afterClose({ pageUrl, crmId });
        }
    }

    return (
        <A_SimpleDialog
            style={{ margin: "auto", width: 300 }}
            formResize={formResize}
            open={open}
            title={title}
            maxWidth="sm"
            onClose={handleClose}
            disableEscapeKeyDown={true}
            dialogContent={
                <React.Fragment>
                    <ErrorBoundary>
                        {data && <>
                            <div className={classes.body}>
                                {data?.map((item, id) => {
                                    return <div className={classes.row} key={id}>
                                        <A_CheckBox
                                            style={{}}
                                            checked={item.enabled}
                                            onChange={(b) => { handleCheckBoxClick(item.displayName, b) }}
                                        />
                                        {item.displayName}
                                    </div>
                                })}
                            </div>
                            <div className={classes.buttons}>
                                <A_Button
                                    label='Save'
                                    onClick={handleSave}
                                    color="primary"
                                />
                            </div>
                        </>}
                        {!data && <div className={classes.loaderContainer}><CircularProgress/></div>}
                    </ErrorBoundary>
                </React.Fragment>
            }
        />

    )
}


KeyFinancialIndicatorForm.propTypes = {
    handleClose: PropTypes.func,
    formResize: PropTypes.any,
    open: PropTypes.bool,
    title: PropTypes.string,
    afterClose: PropTypes.func
}

export default KeyFinancialIndicatorForm